<template>
    <v-list-item :value="props.vessel" color="primary" rounded="xl" append-icon="mdi-chevron-right">
        <v-list-item-title
            ><strong v-html="toHTMLWithSearchTermHighlighted(props.vessel.name, props.searchTerm)"></strong>
            <small>({{ props.vessel.type }})</small></v-list-item-title
        >
        <v-list-item-subtitle><span v-html="toHTMLWithSearchTermHighlighted(addressLine(props.vessel), props.searchTerm)"></span></v-list-item-subtitle>
        <v-list-item-subtitle class="mt-1">
            <span v-html="toHTMLWithSearchTermHighlighted(`Account #${props.vessel.accountId}`, `Account #${props.searchTerm}`)"></span>,
            <span v-html="toHTMLWithSearchTermHighlighted(`Vessel #${props.vessel.vesselId}`, `Vessel #${props.searchTerm}`)"></span>
        </v-list-item-subtitle>
    </v-list-item>
</template>

<script lang="ts" setup>
import { type VesselSearchResultV1 } from '@geckoal/gecko-api-client'
import { type PropType } from 'vue'
import { toHTMLWithSearchTermHighlighted } from '../../lib/utils'

const props = defineProps({
    vessel: {
        type: Object as PropType<VesselSearchResultV1>,
        required: true
    },
    searchTerm: {
        type: String
    }
})

const addressLine = (vessel: VesselSearchResultV1) => {
    if (!vessel) return undefined

    const { location } = vessel
    if (!location) return undefined

    let line = ''
    if (location.line1) line += location.line1
    if (location.locality || location.administrativeAreaLevel1) line += ', '
    if (location.locality) line += location.locality
    if (location.locality && location.administrativeAreaLevel1) line += ' '
    if (location.administrativeAreaLevel1) line += location.administrativeAreaLevel1
    return line
}
</script>

<style lang="scss" scope>
small {
    color: #666;
    margin-left: 8px;
}
</style>
